import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import {
  BUTTON_BRAND_CLASSES,
  BUTTON_BRAND_ALT_COLOR_CLASS,
} from 'constants/buttonClasses';

import { BUTTON_STYLES } from 'styles/button';

const StyledLink = styled.a`
  ${BUTTON_STYLES}
`;

const LinkButton = ({
  addTopMargin,
  addRightMargin,
  altColor,
  className,
  href,
  isExternal,
  label,
  target,
  ...rest
}) => (
  <StyledLink
    href={href}
    target={target}
    rel={isExternal ? 'noopener' : ''}
    addTopMargin={addTopMargin}
    addRightMargin={addRightMargin}
    tabIndex="0"
    className={`${BUTTON_BRAND_CLASSES} ${className} ${
      altColor ? BUTTON_BRAND_ALT_COLOR_CLASS : ''
    }`}
    {...rest}
  >
    {label}
  </StyledLink>
);

LinkButton.propTypes = {
  addTopMargin: PropTypes.bool,
  addRightMargin: PropTypes.bool,
  altColor: PropTypes.bool,
  className: PropTypes.string,
  href: PropTypes.string.isRequired,
  isExternal: PropTypes.bool,
  label: PropTypes.string.isRequired,
  target: PropTypes.string,
};

LinkButton.defaultProps = {
  addTopMargin: false,
  addRightMargin: false,
  altColor: false,
  className: '',
  isExternal: false,
  target: '_blank',
};

export default LinkButton;
